import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.821.09A.448.448 0 0 1 14 .448v10.856a.448.448 0 0 1-.573.43L7.651 10.06 4.023 9.02h-.002l-1.325-.385-2.374-.69A.448.448 0 0 1 0 7.515V4.228c0-.2.132-.375.324-.43L13.428.017a.448.448 0 0 1 .393.072Zm-.717.953L.896 4.565v2.614l2.05.596 1.324.384h.002L7.9 9.2l5.205 1.509V1.043Z",
  fill: "#F59600"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m2 7.6 5.84 1.692v.633a2.92 2.92 0 1 1-5.84 0V7.599Zm.896 1.192v1.133a2.023 2.023 0 0 0 4.048.04L2.896 8.792Z",
  fill: "#F59600"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };